enum Feature {
  SummaryCharts = "SummaryCharts",
  Charts = "Charts",
  AutoProgressiveImageLoading = "AutoProgressiveImageLoading",
}

export default Feature;
